import canUser from '@pkg/entities/users/access/can';

/**
 * @param {Object} me
 * @param {Object} permissions
 * @returns {Boolean}
 */
export default function manage(me, permissions) {
  return canUser(me, permissions.design.manage);
}
